import React from "react";

const HiddenCell = () => {
  return <></>;
};

export default HiddenCell;
